// extracted by mini-css-extract-plugin
export default {"About":"About_About__n8fe1","Section":"About_Section__TwDhS","Top":"About_Top__etM+A","Content":"About_Content__eiDPH"};